import React, { useState, useEffect } from "react";
import { Button, Container } from "react-bootstrap";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Проверяем в localStorage, было ли уже согласие
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    // Закрываем плашку и сохраняем согласие в localStorage
    localStorage.setItem("cookieConsent", "true");
    setShow(false);
  };

  if (!show) return null; // Если согласие дано, не показываем плашку

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "30px",
        backgroundColor: "#f8f9fa", // Цвет фона плашки
        color: "#212529", // Цвет текста
        padding: "8px 0",
        textAlign: "center",
        borderTop: "2px solid #d31918", // Красная граница сверху
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
        zIndex: 9999,
        fontSize: "12px",
        maxWidth: "350px", // Ограничиваем ширину плашки
        width: "100%", // Плашка будет занимать всю ширину до максимальной
      }}
    >
      <Container>
        <p style={{ marginBottom: "5px" }}>
          Мы используем файлы cookie для улучшения вашего опыта. Используя наш сайт, вы соглашаетесь на использование cookie.
        </p>
        <Button
          variant="warning"
          size="sm"
          onClick={handleClose}
          style={{
            padding: "6px 12px",
            fontSize: "12px",
            borderRadius: "20px",
            backgroundColor: "#d31918", // Новый цвет кнопки
            border: "none",
            color: "#fff",
            marginTop: "10px", // Добавим отступ сверху для кнопки
            transition: "background-color 0.3s, color 0.3s", // Плавное изменение цвета
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#a40f10"; // Цвет фона при наведении
            e.target.style.color = "#fff"; // Цвет текста при наведении
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#d31918"; // Восстановление исходного цвета
            e.target.style.color = "#fff"; // Восстановление исходного цвета текста
          }}
        >
          Принять
        </Button>
      </Container>
    </div>
  );
};

export default CookieConsent;
